export enum SocialsNetworks {
  instagram = 'instagram',
  facebook = 'facebook',
  whatsapp = 'whatsapp',
  linkedin = 'linkedin',
}
